<template>
  <div>
    <div class="home">
      <div class="home_background" style="background-image: url(images/home.jpg)"></div>
      <div class="home_content">
        <div class="home_content_inner">
          <div class="home_text_small">Wiadomości</div>
        </div>
      </div>
    </div>
    <div class="m-manage-area">
      <table class="m-manage-table">
        <thead>
          <td>Imię</td>
          <td>Email</td>
          <td>Temat</td>
          <td>Treść</td>
          <td>Data utworzenia</td>
          <td>Data modyfikacji</td>
        </thead>
        <tr v-for="contact in contacts" :key="contact.id">
          <td>{{ contact.name }}</td>
          <td>{{ contact.email }}</td>
          <td>{{ contact.topic }}</td>
          <td>{{ contact.text }}</td>
          <td>{{ contact.created_at }}</td>
          <td>{{ contact.modified_at }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import cli from '@/http.js'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Contacts',
  data() {
    return {
      contacts: [],
    }
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  async created() {
    if (!this.loggedUser) {
      this.$router.push({ name: 'home' })
    }
    cli.patch('/users/me/', { checked_contacts_at: moment() })
    await this.fetchContacts()
  },
  methods: {
    async fetchContacts(pageNumber = 1) {
      let url = '/contacts/'
      url += `?page=${pageNumber}`
      const resp = await cli.get(url)
      this.contacts.push(...resp.data.results)
      if (resp.data.next) {
        pageNumber += 1
        await this.fetchSubscriptions(pageNumber)
      }
    },
  },
}
</script>
